export default __webpack_public_path__ + "static/media/binance-network-switch.ae99cfec.svg";